import runtimeConfig from '@super-template/core/src/runtimeConfig';
import Keycloak from 'keycloak-js';

let keycloak;

export default () =>
  (keycloak ??= new Keycloak(
    runtimeConfig.keycloak ?? {
      url: process.env.REACT_APP_KEYCLOAK_URL,
      realm: process.env.REACT_APP_KEYCLOAK_REALM,
      clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
    }
  ));
